webpackJsonp([6083476834144],{

/***/ 1501:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PatientRegistration","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"patientId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-patient-registration-fcc3316cfc820eb4c062.js